import React from 'react';
import PropTypes from 'prop-types';

export const FormHeader = ({ children }) => {
  return <div className="swformsection__header">{children}</div>;
};

FormHeader.propTypes = {
  children: PropTypes.any
};
